// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "bs-platform/lib/es6/belt_Int.js";
import * as Button$Xuder from "./Button.bs.js";
import * as Events$Xuder from "../utils/Events.bs.js";
import * as Dropdown$Xuder from "./Dropdown.bs.js";
import * as TextInput$Xuder from "./TextInput.bs.js";
import * as XuderContext$Xuder from "../context/XuderContext.bs.js";

function AmericanForm(Props) {
  var onDrawImage = Props.onDrawImage;
  var state = XuderContext$Xuder.useState(/* () */0);
  var match = React.useReducer((function (param, v) {
          return v;
        }), 1);
  var setTimeBefore = match[1];
  var timeBefore = match[0];
  var match$1 = React.useReducer((function (param, v) {
          return v;
        }), 2);
  var setTimeAfter = match$1[1];
  var timeAfter = match$1[0];
  var match$2 = React.useReducer((function (param, v) {
          return v;
        }), undefined);
  var setContract = match$2[1];
  var contract = match$2[0];
  return React.createElement(React.Fragment, undefined, React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Time Before"), React.createElement(TextInput$Xuder.make, {
                      value: String(timeBefore),
                      type_: "number",
                      onChange: (function (e) {
                          var match = Belt_Int.fromString(Events$Xuder.targetValue(e));
                          return Curry._1(setTimeBefore, match !== undefined ? match : 0);
                        }),
                      name: "timebefore"
                    })), React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Time After"), React.createElement(TextInput$Xuder.make, {
                      value: String(timeAfter),
                      type_: "number",
                      onChange: (function (e) {
                          var match = Belt_Int.fromString(Events$Xuder.targetValue(e));
                          return Curry._1(setTimeAfter, match !== undefined ? match : 0);
                        }),
                      name: "timeafter"
                    })), React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Contract"), React.createElement(Dropdown$Xuder.make, {
                      values: $$Array.map((function (value) {
                              return /* tuple */[
                                      value[0],
                                      value[0]
                                    ];
                            }), $$Array.of_list(state[/* contracts */3])),
                      onChange: (function (e) {
                          return Curry._1(setContract, List.find((function (c) {
                                              return c[0] === Events$Xuder.targetValue(e);
                                            }), state[/* contracts */3])[1]);
                        }),
                      name: "contract"
                    })), React.createElement(Button$Xuder.make, {
                  children: "Draw & Save",
                  onClick: (function (_e) {
                      if (contract !== undefined) {
                        return Curry._1(onDrawImage, /* American */Block.__(2, [
                                      /* timeAfter */timeAfter,
                                      /* timeBefore */timeBefore,
                                      /* contract */contract
                                    ]));
                      } else {
                        return /* () */0;
                      }
                    })
                }));
}

var make = AmericanForm;

export {
  make ,
  
}
/* react Not a pure module */
